import checkAutoplayPolicy from './checkAutoplayPolicy';
import Logger from './Logger';
import BugReporter from './BugReporter';
import createObservable from './createObservable';
import createObserver from './createObserver';
var Observer = {
    createObservable: createObservable,
    createObserver: createObserver
};
export { BugReporter, Logger, checkAutoplayPolicy, Observer };
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@lifesize/web-clients-core/dist/es5-module/index.js
// module id = 236
// module chunks = 0